import React from 'react'

const line = { fill: 'none', stroke: 'currentColor', strokeWidth: 1.8 }
const round = { strokeLinecap: 'round', strokeLinejoin: 'round' }

const ICONS = {
  factory: (
    <svg viewBox="0 0 24 24" {...line} strokeLinejoin="round">
      <path d="M3 21V10l5 3V10l5 3V10l5 3V4h3v17z" />
      <path d="M7 17h2M12 17h2M17 17h1" />
    </svg>
  ),
  dc: (
    <svg viewBox="0 0 24 24" {...line} strokeLinejoin="round">
      <path d="M2 9l10-5 10 5v12H2z" />
      <path d="M6 21v-8h12v8M6 16h12" />
    </svg>
  ),
  rsc: (
    <svg viewBox="0 0 24 24" {...line} strokeLinejoin="round">
      <path d="M1 6h13v10H1zM14 10h4l3 3v3h-7z" />
      <circle cx="5" cy="18" r="2" />
      <circle cx="17" cy="18" r="2" />
    </svg>
  ),
  csc: (
    <svg viewBox="0 0 24 24" {...line} {...round}>
      <path d="M3 4h18v6H3zM3 14h18v6H3z" />
      <path d="M7 7h3M7 17h3M15 7h2M15 17h2" />
    </svg>
  ),
  consumer: (
    <svg viewBox="0 0 24 24" {...line} strokeLinecap="round">
      <circle cx="12" cy="8" r="4" />
      <path d="M4 21c0-4 4-6 8-6s8 2 8 6" />
    </svg>
  ),
  cscan: (
    <svg viewBox="0 0 24 24" {...line} {...round}>
      <rect x="6" y="2" width="12" height="20" rx="2" />
      <path d="M9 7h2M13 7h2M9 7v2M15 7v2M9 15v2h2M15 15v2h-2" />
      <path d="M8.5 12h7" />
    </svg>
  ),
  ret2c: (
    <svg viewBox="0 0 24 24" {...line} {...round}>
      <path d="M9 14L4 9l5-5" />
      <path d="M4 9h11a5 5 0 010 10h-3" />
    </svg>
  ),
  transhub: (
    <svg viewBox="0 0 24 24" {...line} strokeLinecap="round">
      <circle cx="12" cy="12" r="3" />
      <circle cx="4" cy="5" r="2" />
      <circle cx="20" cy="5" r="2" />
      <circle cx="4" cy="19" r="2" />
      <circle cx="20" cy="19" r="2" />
      <path d="M6 6.5l4 3.5M18 6.5l-4 3.5M6 17.5l4-3.5M18 17.5l-4-3.5" />
    </svg>
  ),
  adc: (
    <svg viewBox="0 0 24 24" {...line} strokeLinejoin="round">
      <path d="M4 21V3h10v18M14 8h6v13M2 21h20" />
      <path d="M7 7h1M10 7h1M7 11h1M10 11h1M7 15h1M10 15h1M17 12h1M17 16h1" />
    </svg>
  ),
  store: (
    <svg viewBox="0 0 24 24" {...line} strokeLinejoin="round">
      <path d="M3 9l2-5h14l2 5" />
      <path d="M3 9a3 3 0 006 0 3 3 0 006 0 3 3 0 006 0" />
      <path d="M5 12v9h14v-9M10 21v-5h4v5" />
    </svg>
  ),
  ret2b: (
    <svg viewBox="0 0 24 24" {...line} {...round}>
      <path d="M21 8l-9-5-9 5v8l9 5 9-5z" />
      <path d="M3 8l9 5 9-5M12 13v8" />
      <path d="M8 5.5l9 5" />
    </svg>
  ),
  rework: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...round}>
      <path d="M14.7 6.3a4 4 0 005 5L21 13l-8 8-3-3 1.7-1.3a4 4 0 00-5-5L3 10l8-8 3 3z" />
      <path d="M9 15l-6 6" />
    </svg>
  ),
  reprint: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
      <path d="M6 9V3h12v6" />
      <path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2" />
      <path d="M6 14h12v7H6z" />
    </svg>
  ),
  loop: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" {...round}>
      <path d="M21 12a9 9 0 11-3-6.7" />
      <path d="M21 4v5h-5" />
    </svg>
  ),
  question: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" {...round}>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9a2.5 2.5 0 015 .5c0 1.7-2.5 2-2.5 4" />
      <path d="M12 17h.01" />
    </svg>
  )
}

export const Swoosh = props => (
  <svg viewBox="0 0 64 24" {...props}>
    <path
      fill="currentColor"
      d="M64 0.5L19.5 19.3C15.8 20.9 12.7 21.6 10.2 21.6 7.4 21.6 5.4 20.6 4.1 18.6 2.4 16 3.1 11.9 5.9 7.6 7.6 5 9.7 2.7 11.8 0.5 11.3 1.3 6.9 8.5 11.7 12 12.6 12.7 13.9 13 15.5 13 16.8 13 18.2 12.8 19.8 12.4z"
    />
  </svg>
)

const EpcCycleIcon = ({ name }) => ICONS[name] || null

export default EpcCycleIcon
